import GamePlayer from "../page_elements/GamePlayer";
import { useParams } from "react-router-dom";
import Topbar from '../page_elements/Topbar';


export default function GamePage() {
  const params = useParams();
  let gameId = params.gameId;
  let consoleId = params.consoleId;

  return <>
    <Topbar/>
    <GamePlayer id={gameId} consoleId={consoleId} />;
  </>
}
